export class CloudPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsPrincipal",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpPrincipal",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
